/**
* Video Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'video-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.video-slider' ).length ) {
        $( '.video-slider' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'slide',
            gap: '2rem',
            perPage: 2,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1269: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          const progressBar = slider.root.querySelector( '.video-slider__progress-bar' );
          const progressAmount = slider.root.querySelector( '.video-slider__progress-amount' );

          slider.on( 'mounted move', function( newIndex, prevIndex, destIndex ) {
            const end = slider.Components.Controller.getEnd() + 1;
            const slideCount = slider.Components.Slides.getLength();
            const rate = Math.min( ( slider.index + 1 ) / end, 1 );
            progressBar.style.width = String( 100 * rate ) + '%';

            /* updates sr-only text of progress bar */
            if ( slideCount >= 3 ) {
              $( progressAmount ).text( `${slider.index + 3} of ${slideCount} cards` );
            } else {
              $( progressAmount ).text( `${slideCount} of ${slideCount} cards` );
            }
          } );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              drag: isOverflow,
            };
          } );
          slider.mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-slider', COMPONENT );
} )( app );
